const jqlQuery = 'created >= -30d order by created DESC';
const issueNavigatorParams = new URLSearchParams({ jql: jqlQuery });
export const ISSUE_NAVIGATOR_URL = `/issues/?${issueNavigatorParams.toString()}`;

export const generateSmartQueryAdvancedSearchUrl = (query: string) => {
	const searchParams = new URLSearchParams({ searchString: query });
	return `/secure/QuickSearch.jspa?${searchParams.toString()}`;
};
